import React, { createContext, useEffect, useState } from "react";

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    avatar: "",
    phone: {
      code: "1",
      value: "",
    },
    primaryEmail: "",
    address: {
      location: "",
      city: "",
      addressLine1: "",
      state: "",
      county: "",
      country: "",
      apartmentNo: "",
      zip: "",
      landmark: "",
    },
    demographics: {
      race: "",
      dob: "",
    },
    isAuthenticated: false,
  });

  const [activeBrand, setActiveBrand] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed) {
          setUserDetails(parsed);
        }
      }
    } catch (e) {
      // Invalid JSON in localStorage — clear it
      localStorage.removeItem("user");
    }
  }, []);

  const value = {
    userDetails,
    setUserDetails,
    activeBrand,
    setActiveBrand,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContextProvider;
